/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectRouteDeletedDtoBase
 * auto generated base class for the model ProjectRouteDeletedDtoModel.
 *
 * Read only view event
 */
export const ProjectRouteDeletedDtoModelBase = ModelBase
  .named('ProjectRouteDeletedDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteDeletedDto"), "ProjectRouteDeletedDto"),
    projectId: types.union(types.undefined, types.string),
    routeId: types.union(types.undefined, types.string),
    /** Route name */
    name: types.union(types.undefined, types.string),
    /** Route driver's name */
    driverName: types.union(types.undefined, types.null, types.string),
    stopsCount: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectRouteDeletedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  get routeId() { return this.__attr(`routeId`) }
  get name() { return this.__attr(`name`) }
  get driverName() { return this.__attr(`driverName`) }
  get stopsCount() { return this.__attr(`stopsCount`) }
}
export function selectFromProjectRouteDeletedDto() {
  return new ProjectRouteDeletedDtoModelSelector()
}

export const projectRouteDeletedDtoModelPrimitives = selectFromProjectRouteDeletedDto().projectId.routeId.name.driverName.stopsCount
